/*
 * Fast Track (Priority delivery) for the whole order.
 * One Fast Track line (quantity 1) + one cart attribute covers every
 * made-to-order piece in the order, whatever the order total.
 */
(function () {
  var ATTRIBUTE = 'Priority delivery';
  var ATTRIBUTE_VALUE = 'Yes, whole order (3–4 weeks)';

  async function getCart() {
    var response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Could not load cart');
    return response.json();
  }

  async function updateCart(body) {
    var response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    var data = await response.json();
    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Could not update priority delivery');
    }
    return data;
  }

  function fastTrackQuantity(cart, variantId) {
    return cart.items
      .filter(function (item) { return item.variant_id === variantId; })
      .reduce(function (total, item) { return total + item.quantity; }, 0);
  }

  // Exactly one Fast Track line + the order attribute. Safe to call repeatedly.
  async function enable(variantId) {
    variantId = Number(variantId);
    if (!variantId) return;

    var cart = await getCart();
    var hasAttribute = cart.attributes && cart.attributes[ATTRIBUTE];
    if (fastTrackQuantity(cart, variantId) === 1 && hasAttribute) return cart;

    var updates = {};
    updates[variantId] = 1;
    var attributes = {};
    attributes[ATTRIBUTE] = ATTRIBUTE_VALUE;

    return updateCart({ updates: updates, attributes: attributes });
  }

  async function disable(variantId) {
    variantId = Number(variantId);
    var updates = {};
    if (variantId) updates[variantId] = 0;
    var attributes = {};
    attributes[ATTRIBUTE] = '';

    return updateCart({ updates: updates, attributes: attributes });
  }

  async function isActive(variantId) {
    var cart = await getCart();
    return fastTrackQuantity(cart, Number(variantId)) > 0;
  }

  // Cart page: fixes the cart if it is out of sync, then reloads.
  var syncing = false;

  async function syncFromDom() {
    var el = document.querySelector('[data-cart-fast-track]');
    if (!el || syncing) return;

    var variantId = Number(el.dataset.variantId);
    var madeToOrder = Number(el.dataset.madeToOrderCount);
    var quantity = Number(el.dataset.fastTrackQuantity);
    var hasAttribute = el.dataset.hasAttribute === 'true';
    if (!variantId) return;

    var action = null;
    if (madeToOrder === 0 && (quantity > 0 || hasAttribute)) action = 'disable';
    else if (quantity > 1) action = 'enable';
    else if (quantity === 1 && !hasAttribute) action = 'enable';
    else if (quantity === 0 && hasAttribute) action = 'disable';

    if (!action) return;

    syncing = true;
    try {
      if (action === 'enable') await enable(variantId);
      else await disable(variantId);
      window.location.reload();
    } catch (error) {
      console.error('Fast Track sync error:', error);
      syncing = false;
    }
  }

  // Cart box checkbox (delegated, so it survives section re-renders)
  document.addEventListener('change', async function (event) {
    var input = event.target.closest('[data-cart-fast-track-toggle]');
    if (!input) return;

    var el = input.closest('[data-cart-fast-track]');
    var variantId = el && el.dataset.variantId;
    input.disabled = true;

    try {
      if (input.checked) await enable(variantId);
      else await disable(variantId);
      window.location.reload();
    } catch (error) {
      console.error('Fast Track error:', error);
      input.checked = !input.checked;
      input.disabled = false;
    }
  });

  document.addEventListener('DOMContentLoaded', syncFromDom);

  window.LongveFastTrack = { enable: enable, disable: disable, isActive: isActive, syncFromDom: syncFromDom };
})();